/**
 * Los datos que ambos documentos legales comparten.
 *
 * Titular, contacto y fecha estaban escritos a mano adentro de la política de
 * privacidad y otra vez adentro de los términos, con la fecha desincronizada
 * entre los dos. Cambiar un correo obligaba a acordarse de los dos archivos, y
 * un documento legal que se contradice consigo mismo no sirve de nada.
 *
 * Si cambia el titular, el domicilio o el correo, se cambia acá y sale en los
 * dos documentos y en el pie de las dos páginas.
 */

export const RESPONSABLE = {
  nombre: 'Matías Calo',
  domicilio: 'Ciudad Autónoma de Buenos Aires, Argentina',
  email: 'matiascalo@aturno.app',
  sitio: 'https://aturno.app',
};

/**
 * Se actualiza a mano cuando el texto cambia de verdad.
 *
 * No sale de `new Date()` a propósito: la fecha tiene que decir cuándo cambió
 * el documento, no cuándo se abrió la página. Una política que dice "última
 * actualización: hoy" todos los días no le informa nada a nadie, y además es
 * falsa.
 */
export const ULTIMA_ACTUALIZACION = 'agosto de 2026';
